module.exports = __webpack_public_path__ + "static/media/square-doc.e4661278.svg";